import { categoryCards } from "../../../mocks/homeData";
import SectionHeading from "./SectionHeading";

const iconStyle = [
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-900",
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-900",
];

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-16 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="栏目分类"
          title="六大栏目"
          highlight="按瓜入座"
          desc="不同圈层的大瓜节奏各不相同，按栏目归类整理，让你想追哪路就直扑哪路，不错过本圈的关键爆点。"
        />
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryCards.map((c, i) => (
            <a
              key={c.key}
              href="#tracking"
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-accent-300 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${iconStyle[i]}`}>
                  <i className={`${c.icon} w-5 h-5 flex items-center justify-center`}></i>
                </span>
                <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-900">
                  {c.count} 条追踪
                </span>
              </div>
              <h3 className="mt-4 font-serif text-lg font-bold text-foreground-950">{c.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-700">
                进入栏目追踪
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}